// extracted by mini-css-extract-plugin
export var dropdown = "NavItem-module--dropdown--UBqJp";
export var dropdownItem = "NavItem-module--dropdownItem--kSEqs";
export var navLink = "NavItem-module--navLink--nb2Rq";
export var root = "NavItem-module--root--MxcP0";